import { BREADCRUMB } from "./types";

export const editarBreadcrumb = ( rutas ) => dispatch => {
    dispatch({
        type: BREADCRUMB.EDITAR,
        payload: rutas
    });
}